export default "__VITE_ASSET__CedLOxOp__"